module.exports = __webpack_public_path__ + "static/media/pedido-entregado-gray.3b116c45.svg";